export const locationImage = (placeId: string) => ['location-image', placeId] as const
